<template>
  <div id="contenedor-main-contrato-superintendentes">
    <tool-bar
      class="my-3"
      v-on:registrarSuperintendente="mostrarRegistrarSuperintendente = true"
    />
    <listado :listadoSuperintendentes="getSuperintendentes" />
    <v-dialog v-model="mostrarRegistrarSuperintendente" width="500">
      <registrar-superintendente
        :contratoId="idContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog
      v-if="esteSuperintendente"
      v-model="mostrarEliminarSuperintendente"
      width="500"
    >
      <eliminar-superintendente
        :superintendenteEliminar="esteSuperintendente"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_SUPERINTENDENTES from '@/graphql/querys/administracion/contratos/superintendente/contratoSuperintendentes.gql';
import RegistrarSuperintendente from '@/components/administracion/contratos/contrato/superintendente/Nuevo.vue';
import EliminarSuperintendente from '@/components/administracion/contratos/contrato/superintendente/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from '@/views/administracion/contratos/contrato/superintendentes/listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoMainSuperintendente',
  components: {
    ToolBar,
    Listado,
    RegistrarSuperintendente,
    EliminarSuperintendente,
  },
  data() {
    return {
      mostrarRegistrarSuperintendente: false,
      mostrarEliminarSuperintendente: false,
      esteSuperintendente: null,
      idContrato: this.$route.params.idContrato,
    };
  },
  apollo: {
    contratoSuperintendentes: {
      query: CONTRATO_SUPERINTENDENTES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarRegistrarSuperintendente = false;
      this.mostrarEliminarSuperintendente = false;
      this.esteSuperintendente = null;
    },
  },
  computed: {
    getSuperintendentes() {
      if (!this.contratoSuperintendentes) return [];
      return this.contratoSuperintendentes;
    },
  },
  mounted() {
    eventBus.$on('borrar-superintendente-contrato', (superintendente) => {
      this.esteSuperintendente = superintendente;
      this.mostrarEliminarSuperintendente = true;
    });
  },
};
</script>

<style lang="scss">
</style>
